import React, { useState } from 'react';
import ModalContent from '../routes/SmartInspect/Warren/assets/ModalContent';
import { FaClipboardList, FaBookOpen } from 'react-icons/fa';
import { BsPencil } from 'react-icons/bs';
import { MdSyncProblem } from 'react-icons/md';
import { RiComputerLine } from 'react-icons/ri';
import { TbTrafficCone } from 'react-icons/tb';
import { VscTools } from 'react-icons/vsc';
import { Breadcrumb, Dropdown, Tooltip, OverlayTrigger, Modal, Form, Button } from 'react-bootstrap';
import { FaHome, FaPowerOff, FaLightbulb, FaUserPlus } from 'react-icons/fa';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';

const HomeNav = ({ plant, home }) => {
	const [navState, setNavState] = useState('');

	// modal state and handlers
	const [modal, setModal] = useState({
		title: '',
		content: '',
	});
	const [showModal, setShowModal] = useState(false);
	const handleShowModal = (title, content) => {
		setModal({ title: title, content: content });
		setShowModal(true);
	};
	return (
		<>
			<nav class="home-nav">
				<ul class="d-flex justify-content-center p-0">
					<Dropdown drop={'down'}>
						<Dropdown.Toggle className="operation-element">
							<RiComputerLine size={'4vw'} />
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Item onClick={() => handleShowModal('Introduction to SMARTInspect', 'intro')}>Intro</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Configuration File Setup', 'config-setup')}>Configuration File Setup</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Manual Stop / Start Procedure', 'start-stop')}>Manual Stop / Start Procedure</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Server Power Shutdown / Startup', 'startup-shutdown')}>Server Power Startup / Shutdown</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Side-by-Side View', 'horizontal-layout')}>Side-by-Side View</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Top-Bottom View', 'vertical-layout')}>Top-Bottom View</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Plugin Menu', 'plugin-menu')}>Plugin Menu</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Service Sidebar', 'service-sidebar')}>Sidebar Service Monitor</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Camera Status Sidebar', 'quick-cam-status')}>Camera Status Sidebar</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Fault Alert Bar', 'fault-viewer')}>Fault Alert Bar</Dropdown.Item>

							<Dropdown.Item onClick={() => handleShowModal('All Camera Status', 'camera-status')}>All Camera Status</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Job Queue', 'job-queue')}>Job Queue</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Service Process Viewer', 'service-process-viewer')}>Service Process Monitor</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Server Process Monitor', 'server-process-monitor')}>Server Process Monitor</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Service Monitor', 'service-monitor')}>Service Monitor</Dropdown.Item>

							<Dropdown.Item onClick={() => handleShowModal('Scans Report', 'scans')}>Scans Report</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Scan Rate', 'scan-rate')}>Scan Rate</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Defects', 'defects')}>Defects</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Defect Detail', 'defect-detail')}>Defect Detail</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Faults', 'faults')}>Faults</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Offline Services', 'offline-services')}>Offline Services</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Change Log', 'change-log')}>Change Log</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Qvs Fault Viewer', 'QVS-fault-viewer')}>Qvs Fault Viewer</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Qvs Scan History', 'QVS-scan-history')}>Qvs Scan History</Dropdown.Item>

							<Dropdown.Item onClick={() => handleShowModal('Hot Spot Editor', 'hotspot')}>Hot Spot Editor</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Style Setup and Plant Color Setup', 'style-setup')}>Style Set-Up</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Style Setup and Plant Color Setup', 'style-setup')}>Plant Color Set-Up</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Style Setup and Plant Color Setup', 'plant-color')}>Plant Color Family Set-Up</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Plant Camera Override Setup', 'plant-camera-override')}>Plant Camera Override Set-Up</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('JSON Editor', 'json-editor')}>JSON Editor</Dropdown.Item>

							<Dropdown.Item onClick={() => handleShowModal('Defect Heat Map', 'defect-map')}>Defect Heat Map</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Network Diagnostic', 'network-diagnostic')}>Network Diagnostic</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Basic User Setup', 'user-setup')}>New User Set-Up</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('PLC IO', 'plc-io')}>PLC I/O</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Baseline Setup', 'baseline-setup')}>Baseline Setup</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('Calculator', 'calculator')}>Calculator</Dropdown.Item>

							<Dropdown.Item onClick={() => handleShowModal('System Recovery', 'recovery-screen')}>System Recovery</Dropdown.Item>
							<Dropdown.Item onClick={() => handleShowModal('About', 'about')}>About</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>

					<Dropdown drop={'down'}>
						<Dropdown.Toggle className="safety-element">
							<TbTrafficCone size={'4vw'} />
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Item href={`/smart-inspect/${plant}/safety/safety-overview`}>Safety Overview</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/safety/control-safety`}>Control Safety</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/safety/safety-devices`}>Safety Devices</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/safety/equipment-lockout`}>Equipment Lockout</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/safety/energy-sources`}>Energy Sources</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>

					<Dropdown drop={'down'}>
						<Dropdown.Toggle className="equipment-element">
							<FaClipboardList size={'4vw'} />
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Item href={`/smart-inspect/${plant}/equipment/equipment-overview`}>Equipment Overview</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/equipment/assemblies`}>Assemblies</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/equipment/electrical-panels`}>Electrical Panels</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/equipment/system-control`}>System Control</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/equipment/part-detect`}>Part Detect Skid</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>

					<Dropdown drop={'down'}>
						<Dropdown.Toggle className="maintenance-element">
							<VscTools size={'4vw'} />
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Item href={`/smart-inspect/${plant}/maintenance/maintenance-overview`}>Maintenance Overview</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/maintenance/maintenance-safety`}>Maintenance Safety</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/maintenance/preventive-maintenance`}>Preventive Maintenance</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/maintenance/maintenance-lockout`}>Maintenance Lockout Procedure</Dropdown.Item>
							{/* <Dropdown.Item href="/smart-inspect/${plant}/maintenance/oem-maintenance">OEM Maintenance</Dropdown.Item> */}
							<Dropdown.Item href={`/smart-inspect/${plant}/maintenance/maintenance-procedures`}>Maintenance Procedures</Dropdown.Item>
							{/* <Dropdown.Item href="/smart-inspect/${plant}/maintenance/machine-ledgers">Machine Ledgers</Dropdown.Item> */}
						</Dropdown.Menu>
					</Dropdown>

					<Dropdown drop={'down'}>
						<Dropdown.Toggle className="troubleshooting-element">
							<MdSyncProblem size={'4vw'} />
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Item href={`/smart-inspect/${plant}/troubleshooting/troubleshoot-overview`}>Troubleshooting Overview</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/troubleshooting/mechanical-troubleshooting`}>Mechanical Troubleshooting</Dropdown.Item>
							<Dropdown.Item href={`/smart-inspect/${plant}/troubleshooting/electrical-troubleshooting`}>Electrical Troubleshooting</Dropdown.Item>
							{/* <Dropdown.Item href="#">OEM Troubleshooting</Dropdown.Item> */}
							<Dropdown.Item href={`/smart-inspect/${plant}/troubleshooting/smart-inspect-troubleshooting`}>SMARTInspect Troubleshooting</Dropdown.Item>
							{/* <Dropdown.Item href="/smart-inspect/${plant}/troubleshooting/hardware-troubleshooting">Hardware Troubleshooting</Dropdown.Item> */}
						</Dropdown.Menu>
					</Dropdown>

					<Dropdown drop={'down'}>
						<Dropdown.Toggle className="drawing-element" href={`/smart-inspect/${plant}/drawings`}>
							<BsPencil size={'4vw'} />
						</Dropdown.Toggle>
					</Dropdown>

					<Dropdown drop={'down'}>
						<Dropdown.Toggle className="appendix-element">
							<FaBookOpen size={'4vw'} />
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Item>Appendix</Dropdown.Item>
							<Dropdown.Item>Training Docs</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</ul>

				{home && <h1 style={{ marginTop: '30%' }}>Use the buttons above to navigate through each section of the SMARTInspect Manual</h1>}
			</nav>

			<Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="course-modal" centered>
				<Modal.Header closeButton>
					<Modal.Title>{modal.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<ModalContent content={modal.content} />
				</Modal.Body>
			</Modal>
		</>
	);
};

export default HomeNav;
